import React from "react";
import { FiSettings } from "react-icons/fi";

export function MaintenancePage() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-gray-800 px-4 text-center">
      <div className="bg-white shadow-xl rounded-2xl p-8 max-w-md">
        <div className="flex justify-center mb-6">
          <FiSettings className="text-blue-600 w-16 h-16 animate-spin-slow" />
        </div>
        <h1 className="text-3xl font-bold mb-4">We're Under Maintenance</h1>
        <p className="text-gray-600 mb-6">
          Our website is currently undergoing scheduled maintenance. We’ll be
          back shortly. Thank you for your patience!
        </p>
        <p className="text-sm text-gray-400">— The Team</p>
      </div>
    </div>
  );
}
